/** The take-in page of a follow-up version (US-Workflow-10, #55); reached from the Work Queue. */
export const FOLLOWUP_TAKE_IN_ROUTE = "/follow-up-take-in/$caseId" as const;
export const FOLLOWUP_TAKE_IN_PATH_PREFIX = "/follow-up-take-in/";
